// Auto-generated file — do not edit manually
// Generated from: https://consents.almacareer.tech/acl-lda/categorization.json
// Generated at: 2026-03-17T11:28:59.125Z

export const KNOWN_COOKIE_CATEGORY_MAP = [
  { name: 'phpsessid', pattern: 'phpsessid', provider: 'PHP', category: 'necessary' },
  { name: 'jsessionid', pattern: 'jsessionid', provider: 'Java', category: 'necessary' },
  { name: 'aspnetsessionid', pattern: 'aspnetsessionid', provider: 'Microsoft ASP.NET', category: 'necessary' },
  { name: 'sessionid', pattern: 'sessionid', provider: '*', category: 'necessary' },
  { name: 'docs.sid', pattern: 'docs\\.sid', provider: 'Supernova Docs', category: 'necessary' },
  { name: 'lasid', pattern: 'lasid', provider: 'LiveAgent', category: 'necessary' },
  { name: '*_session', pattern: '.*_session', provider: 'Laravel / Rails / Django', category: 'necessary' },
  { name: 'csrf', pattern: 'csrf', provider: '*', category: 'necessary' },
  { name: 'xsrf', pattern: 'xsrf', provider: '*', category: 'necessary' },
  { name: '_token', pattern: '_token', provider: '*', category: 'necessary' },
  { name: 'token', pattern: 'token', provider: '*', category: 'necessary' },
  { name: 'authtoken', pattern: 'authtoken', provider: '*', category: 'necessary' },
  { name: 'idt', pattern: 'idt', provider: '*', category: 'necessary' },
  { name: 'auth.strategy', pattern: 'auth\\.strategy', provider: 'Nuxt Auth', category: 'necessary' },
  { name: 'cf_clearance', pattern: 'cf_clearance', provider: 'Cloudflare', category: 'necessary' },
  { name: '__cfduid', pattern: '__cfduid', provider: 'Cloudflare', category: 'necessary' },
  { name: 'cf_bm', pattern: 'cf_bm', provider: 'Cloudflare', category: 'necessary' },
  { name: 'cf_ray', pattern: 'cf_ray', provider: 'Cloudflare', category: 'necessary' },
  { name: 'apprace*', pattern: 'apprace*', provider: 'Prace.cz', category: 'necessary' },
  { name: 'apjobs*', pattern: 'apjobs*', provider: 'Jobs.cz', category: 'necessary' },
  { name: 'jobssid', pattern: 'jobssid', provider: 'Jobs portál', category: 'necessary' },
  { name: 'apatmoskopid', pattern: 'apatmoskopid', provider: 'Atmoskop.cz', category: 'necessary' },
  { name: 'awsalbcors', pattern: 'awsalbcors', provider: 'Amazon Web Services', category: 'necessary' },
  { name: 'awsalb', pattern: 'awsalb', provider: 'Amazon Web Services', category: 'necessary' },
  { name: 'lmc_ccm_version', pattern: 'lmc_ccm_version', provider: 'Alma Career', category: 'necessary' },
  { name: 'almacareer_ccm', pattern: 'almacareer_ccm', provider: 'Alma Career', category: 'necessary' },
  { name: 'cookieyes-consent', pattern: 'cookieyes-consent', provider: 'CookieYes', category: 'necessary' },
  { name: 'cookie-consent', pattern: 'cookie-consent', provider: '*', category: 'necessary' },
  { name: 'gdpr-consent', pattern: 'gdpr-consent', provider: '*', category: 'necessary' },
  { name: 'cmplz*', pattern: 'cmplz.*', provider: 'Complianz', category: 'necessary' },
  { name: 'bsession', pattern: 'bsession', provider: 'Wix', category: 'necessary' },
  { name: 'ssr-caching', pattern: 'ssr-caching', provider: 'Wix', category: 'necessary' },
  { name: 'svsession', pattern: 'svsession', provider: 'Wix', category: 'necessary' },
  { name: 'hs', pattern: 'hs', provider: 'Wix', category: 'necessary' },
  { name: 'server-session-bind', pattern: 'server-session-bind', provider: 'Wix', category: 'necessary' },
  { name: 'intercom-device-id*', pattern: 'intercom-device-id.*', provider: 'Intercom', category: 'functionality' },
  { name: 'intercom-id*', pattern: 'intercom-id.*', provider: 'Intercom', category: 'functionality' },
  { name: 'intercom-session*', pattern: 'intercom-session.*', provider: 'Intercom', category: 'functionality' },
  { name: 'pll_language', pattern: 'pll_language', provider: 'Polylang (WordPress)', category: 'functionality' },
  { name: 'hl', pattern: 'hl', provider: 'Web', category: 'functionality' },
  { name: 'lang', pattern: 'lang', provider: 'Web', category: 'functionality' },
  { name: 'language', pattern: 'language', provider: 'Web', category: 'functionality' },
  { name: 'locale', pattern: 'locale', provider: 'Web', category: 'functionality' },
  { name: 'channel_*_lang', pattern: 'channel_.*_lang', provider: 'Web', category: 'functionality' },
  {
    name: 'wp-wpml_current_language',
    pattern: 'wp-wpml_current_language',
    provider: 'WPML (WordPress)',
    category: 'functionality',
  },
  { name: 'resolution', pattern: 'resolution', provider: 'Web', category: 'functionality' },
  { name: 'trx_addons_is_retina', pattern: 'trx_addons_is_retina', provider: 'ThemeREX', category: 'functionality' },
  { name: 'theme', pattern: 'theme', provider: 'Web', category: 'functionality' },
  { name: 'currency', pattern: 'currency', provider: 'E-shop', category: 'functionality' },
  { name: 'timezone', pattern: 'timezone', provider: 'Web', category: 'functionality' },
  { name: 'view', pattern: 'view', provider: 'Web', category: 'functionality' },
  { name: 'layout', pattern: 'layout', provider: 'Web', category: 'functionality' },
  { name: 'wfont', pattern: 'wfont', provider: 'Web', category: 'functionality' },
  { name: '_ga', pattern: '_ga', provider: 'Google Analytics', category: 'analytics' },
  { name: '_gid', pattern: '_gid', provider: 'Google Analytics', category: 'analytics' },
  { name: '_gat*', pattern: '_gat.*', provider: 'Google Analytics', category: 'analytics' },
  { name: '_ga_*', pattern: '_ga_.*', provider: 'Google Analytics 4', category: 'analytics' },
  { name: '_gali', pattern: '_gali', provider: 'Google Analytics', category: 'analytics' },
  { name: 'user_uuid', pattern: 'user_uuid', provider: '*', category: 'analytics' },
  { name: 'visitor', pattern: 'visitor', provider: '*', category: 'analytics' },
  { name: 'tracking', pattern: 'tracking', provider: '*', category: 'analytics' },
  { name: 'analytics', pattern: 'analytics', provider: '*', category: 'analytics' },
  { name: 'uid_tracker', pattern: 'uid_tracker', provider: '*', category: 'analytics' },
  { name: 'lavisitorid', pattern: 'lavisitorid', provider: 'LiveAgent', category: 'analytics' },
  { name: 'lavisitornew', pattern: 'lavisitornew', provider: 'LiveAgent', category: 'analytics' },
  { name: 'ttcsid', pattern: 'ttcsid', provider: 'TikTok', category: 'ad' },
  { name: '_gcl_au', pattern: '_gcl_au', provider: 'Google Ads', category: 'ad' },
  { name: '_gcl_aw', pattern: '_gcl_aw', provider: 'Google Ads', category: 'ad' },
  { name: '_gcl_dc', pattern: '_gcl_dc', provider: 'Google DoubleClick', category: 'ad' },
  { name: 'gcl_au', pattern: 'gcl_au', provider: 'Google Ads', category: 'ad' },
  { name: 'doubleclick', pattern: 'doubleclick', provider: 'Google DoubleClick', category: 'ad' },
  { name: '_fbp', pattern: '_fbp', provider: 'Meta (Facebook)', category: 'ad' },
  { name: '_fbc', pattern: '_fbc', provider: 'Meta (Facebook)', category: 'ad' },
  { name: 'fr', pattern: 'fr', provider: 'Meta (Facebook)', category: 'ad' },
  { name: '_uetsid', pattern: '_uetsid', provider: 'Microsoft Bing Ads', category: 'ad' },
  { name: '_uetvid', pattern: '_uetvid', provider: 'Microsoft Bing Ads', category: 'ad' },
  { name: 'muid', pattern: 'muid', provider: 'Microsoft', category: 'ad' },
  { name: 'bcookie', pattern: 'bcookie', provider: 'LinkedIn', category: 'ad' },
  { name: 'bscookie', pattern: 'bscookie', provider: 'LinkedIn', category: 'necessary' },
  { name: 'lidc', pattern: 'lidc', provider: 'LinkedIn', category: 'necessary' },
  { name: 'usermatchhistory', pattern: 'usermatchhistory', provider: 'LinkedIn', category: 'ad' },
  { name: 'ads', pattern: 'ads', provider: '*', category: 'ad' },
  { name: 'marketing', pattern: 'marketing', provider: '*', category: 'ad' },
  { name: 'campaign', pattern: 'campaign', provider: '*', category: 'ad' },
  { name: 'utm*', pattern: 'utm.*', provider: '*', category: 'analytics' },
  { name: 'retargeting', pattern: 'retargeting', provider: '*', category: 'ad' },
  { name: 'conversion', pattern: 'conversion', provider: '*', category: 'ad' },
  { name: 'affiliate', pattern: 'affiliate', provider: '*', category: 'ad' },
  { name: 'adsystem', pattern: 'adsystem', provider: '*', category: 'ad' },
  { name: 'admeld', pattern: 'admeld', provider: 'Google AdMeld', category: 'ad' },
] as const;

export type KnownCookieName = (typeof KNOWN_COOKIE_CATEGORY_MAP)[number]['name'];

export type KnownCookieNameByCategory<C> = Extract<(typeof KNOWN_COOKIE_CATEGORY_MAP)[number], { category: C }>['name'];
